import { FunctionalComponent, h } from '@stencil/core';
import { FundDataPoints } from '../../../_interfaces/fund-card/fund-data-points';
import { dataWithChevron } from './_helpers';

interface NetProps {
	flag: boolean;
	dataPointValues: FundDataPoints;
	Tooltip: string;
}

export const Net: FunctionalComponent<NetProps> = ({
	flag,
	dataPointValues,
	Tooltip,
}) => {
	if (flag)
		return (
			<div class="ds-data-points">
				{dataPointValues.general ? (
					<div class="ds-left-col">
						<div class="ds-body-s">
							{dataPointValues.label}&nbsp;
							<Tooltip content={dataPointValues.tooltip.first}></Tooltip>
						</div>
						<div class="ds-fund-data">{dataPointValues.data}</div>
					</div>
				) : null}

				{dataPointValues.secondaryGeneral ? (
					<div class="ds-right-col">
						<div class="ds-body-s">{dataPointValues.secondaryLabel}&nbsp;</div>
						{dataWithChevron(dataPointValues.secondaryData)}
					</div>
				) : null}
			</div>
		);
};
